import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  catchError,
  mergeMap,
} from 'rxjs/operators';
import {
  SPECIAL_PRICE_FIND_ALL,
  SPECIAL_PRICE_FIND_ALL_SUCCESS,
  SPECIAL_PRICE_UPDATE_LOADING,
} from '@store/actions';
import { SpecialPrice } from '@core/models';
import { SpecialPriceService } from '@core/services';

@Injectable()
export class SpecialPriceEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private specialPriceService: SpecialPriceService
  ) { }

  findAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SPECIAL_PRICE_FIND_ALL),
      mergeMap(() => {
        this.store.dispatch(SPECIAL_PRICE_UPDATE_LOADING({ loading: true }));

        return this.specialPriceService.findAll().pipe(
          mergeMap(({ data }) => {
            const specialPriceList = data as SpecialPrice[];
            return [
              SPECIAL_PRICE_FIND_ALL_SUCCESS({ specialPriceList }),
              SPECIAL_PRICE_UPDATE_LOADING({ loading: false }),
            ];
          }),
          catchError((error) => of())
        );
      })
    )
  );
}
